import axiosInstance from "@/axios";

const getEmails = (profileId) =>
  axiosInstance.get(`/api/profile/billing-emails?profileId=${profileId}`);

const patchEmails = (payload, profileId) =>
  axiosInstance.patch(
    `/api/profile/billing-emails?profileId=${profileId}`,
    payload,
  );

export { getEmails, patchEmails };
